// im
export default [
	{
		path: '/im',
		name: 'im',
		component: () => import('@/views/im/index.vue'),
		meta: { title: '日常咨询' }
	}
]
